import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import icobackblue from '../img/ico-backblue.svg';
import icosearch from '../img/ico-search.svg';
import icoclose from '../img/ico-close.svg';
import strings from '../strings.js'
import SingerCard from '../SingerCard';
import SelectingYesNoSinger from '../SelectingYesNoSinger';
import heart from '../img/heart.svg';
import noheart from '../img/noheart.svg';
import { SendMessage } from '../App.js';
import useSingerSearch from '../useSingerSearch';

const API_URL = "https://www.starboxkod.com/api";

const singer1 = {
    "singer_name":"GEM邓紫棋"
}



export function Artists({cookieFavs, setCookieFavs, stateVer, lang, selectingSinger, selectingYesNo, tableNo, selectedSinger, setSelectedSinger, footerDisabled}) {

    const [searchTerm, setSearchTerm] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [searchLang, setSearchLang] = useState("language")

    const singerCategoryOptions = [
  { id: "language", labelKey: "singerall" },
  { id: "M男港台", labelKey: "singercnmale" },
  { id: "F女港台", labelKey: "singercnfemale" },
  { id: "G乐队", labelKey: "singergroup" },
  { id: "欧美", labelKey: "singereurope" },
  { id: "马来", labelKey: "singermalay" },
  { id: "日本", labelKey: "singerjapan" },
  { id: "韩国", labelKey: "singerkorea" },
  { id: "泰国", labelKey: "singerthailand" },
  { id: "印度", labelKey: "singerindia" },
  { id: "越南", labelKey: "singervietnam" },
  { id: "菲律宾", labelKey: "singerphilippine" },
];

    const {
        loading,
        error,
        songs,
        hasMore
    } = useSingerSearch(searchTerm, pageNumber, searchLang)

    const observer = useRef()
    
    const lastSongElementRef = useCallback(node => {
        if (loading) return

        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 20)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore])
    
    function handleSearch(e) {
        setSearchTerm(e.target.value)
    }
    
    useEffect(() => {
        setPageNumber(0)
        document.getElementById("singer-container").scrollTop =0;

      }, [searchTerm, searchLang])


    
    function nowSelectSinger (song) {
        navigate("/home/artists/singer");
        //check if it's empty, if so then intialise
        console.log(song);
        setSelectedSinger(song);
    }
   
    const navigate = useNavigate()

    return (<>
    <div className="heatder">
        <a onClick={(e) => {e.preventDefault(); navigate(-1)}}>
            <img
                src={icoback}
                alt="back"            
            />
        </a>
        <div className = "headersearch">
            <img className = "headersearchIcon"
                src={icosearch}
                alt="search"
                onClick={(e) => {e.preventDefault(); }}
            />
            <input
                placeholder={lang ? strings.cn.search : strings.en.search}
                value={searchTerm}
                onChange={handleSearch}
            />
            <a onClick={(e) => {e.preventDefault(); setSearchTerm("");}}>
            <img className = "headersearchClose"
                src={icoclose}
                alt="search"
                />
            </a>
        </div>

    </div>
    <div className="purpleHeader26">
    <div className ="headerBelow">{lang ? strings.cn.artist : strings.en.artist}</div>
    <div className="language-bar-container">
        <div className="language-bar">
                                {singerCategoryOptions.map((option) => (
                                    <div
                                    key={option.id}
                                    className={`pill-btn ${searchLang === option.id ? "selected" : ""}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setSearchLang(option.id);
                                    }}
                                    >
                                    {lang ? strings.cn[option.labelKey] : strings.en[option.labelKey]}
                                    </div>
                                ))}
        </div>
    </div></div>

    <div className="singer-container" id="singer-container" >
    {songs?.length > 0
        ? (
            <>
                {songs.map((song, index) => {
                    const singerName = song.singer_name || song.singer; // Access the value dynamically
                    if (songs.length == index + 1) {
                        return <SingerCard innerRef={lastSongElementRef} song={singerName} key={singerName} onClick={() => { nowSelectSinger(singerName)}} />
                    } else {
                        return <SingerCard song={singerName} key={singerName} onClick={() => { nowSelectSinger(singerName) }}/>
                    }
                    
                })}     
            </>
        ) :
        (
            <div className="empty">
                <h2>No singers found</h2>
            </div>
        )}
    </div>

    {loading && 'Loading...'}
    {error && 'Error...'}

    { selectingSinger && (
        <>
        <SelectingYesNoSinger cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} footerDisabled={footerDisabled} song={selectedSinger} onClick={() => { navigate(-1);}} stateVer={stateVer} selectingYesNo={selectingYesNo} tableNo={tableNo} lang={lang}/>
        </>
    )}
    
</>)}
